/**
 * Reads the CSP nonce injected by the server into a <meta name="csp-nonce"> tag.
 * The nonce is required for dynamically created inline scripts so they are
 * allowed by the Content-Security-Policy script-src directive.
 */
export function getCspNonce(): string {
    const meta = document.querySelector('meta[name="csp-nonce"]');
    return meta ? meta.getAttribute('content') || '' : '';
}
